import React from "react";
import * as interfaces from "../interfaces/navList";

// 아이콘 리스트
import HomeIcon from "@mui/icons-material/Home";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import DangerousIcon from "@mui/icons-material/Dangerous";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import SchoolIcon from "@mui/icons-material/School";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import LegendToggleIcon from "@mui/icons-material/LegendToggle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import TransformIcon from "@mui/icons-material/Transform";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import EditRoadIcon from "@mui/icons-material/EditRoad";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import CachedIcon from "@mui/icons-material/Cached";
import TaskIcon from "@mui/icons-material/Task";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import ArticleIcon from "@mui/icons-material/Article";
import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ReviewsIcon from "@mui/icons-material/Reviews";
import IsoIcon from "@mui/icons-material/Iso";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import AddchartIcon from "@mui/icons-material/Addchart";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import BusinessIcon from "@mui/icons-material/Business";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import DescriptionIcon from "@mui/icons-material/Description";
export const navMenu: interfaces.NavMenu[] = [
  {
    id: 0,
    icon: <AdminPanelSettingsIcon color="secondary" />,
    caption: "최고 관리자",
    items: [
      {id: 1, icon: <BusinessIcon color="secondary" />, subTitle: "업체", url: "/Company"},
      {
        id: 2,
        icon: <SwitchAccountIcon color="secondary" />,
        subTitle: "업체 관리자",
        url: "/Manager",
      },
      {
        id: 3,
        icon: <LocalFireDepartmentIcon color="secondary" />,
        subTitle: "게시판 관리자",
        url: "/BoardManager",
      },
      {
        id: 4,
        icon: <SwitchAccountIcon color="secondary" />,
        subTitle: "질의, 오류보고",
        url: "/Suggestion/All",
      },
    ],
  },

  {
    id: 1,
    icon: <AssignmentIndIcon color="primary" />,
    caption: "게시판관리자",
    items: [{id: 1, icon: <LocalFireDepartmentIcon />, subTitle: "게시판 목록", url: "/Board"}],
  },
  {
    id: 2,
    icon: <ManageAccountsIcon color="primary" />,
    caption: "관리자설정",
    items: [
      {id: 1, icon: <LocalFireDepartmentIcon />, subTitle: "부서관리", url: "/Department"},
      {
        id: 2,
        icon: <PersonAddAlt1Icon />,
        subTitle: "담당자",
        url: "/Officer",
      },
      {id: 3, icon: <LegendToggleIcon />, subTitle: "통계관련 범례내용", url: "/Statistics"},
      {id: 4, icon: <CreditCardIcon />, subTitle: "신뢰도 관리", url: "/Equipment/Reliability"},

      {id: 5, icon: <ContentPasteIcon />, subTitle: "질의 오류보고", url: "/Suggestion"},
    ],
  },
  {
    id: 3,
    icon: <HomeIcon color="primary" />,
    caption: "Home",
    items: [{id: 1, icon: <QuestionAnswerIcon />, subTitle: "Home", url: "/Home/Dashboard"}],
  },
  {
    id: 4,
    icon: <HomeRepairServiceIcon color="primary" />,
    caption: "설비유지관리",
    items: [
      {id: 1, icon: <CardTravelIcon />, subTitle: "설비이력카드목록", url: "/Equipment"},
      {
        id: 2,
        icon: <TransformIcon />,
        subTitle: "점검 정비 수 발신 목록",
        url: "/WorkOrder",
      },
      {
        id: 3,
        icon: <FormatListBulletedIcon />,
        subTitle: "점검 요청 목록",
        url: "/WorkOrder/RequestedList",
      },
      {id: 4, icon: <HistoryToggleOffIcon />, subTitle: "점검 이력", url: "/WorkOrder/Record"},
      {
        id: 5,
        icon: <EditRoadIcon />,
        subTitle: "의뢰서 작성",
        url: "/WorkOrder/SelectSpecification",
      },
    ],
  },
  {
    id: 5,
    icon: <EngineeringIcon color="primary" />,
    caption: "My 점검·정비목록",
    items: [
      {id: 1, icon: <ReplyAllIcon />, subTitle: "수신목록", url: "/WorkOrder/List/Received"},
      {
        id: 2,
        icon: <CachedIcon />,
        subTitle: "진행목록",
        url: "/WorkOrder/List/Processed",
      },
      {id: 3, icon: <TaskIcon />, subTitle: "완료목록", url: "/WorkOrder/List/Completed"},
    ],
  },
  {
    id: 6,
    icon: <ChangeCircleIcon color="primary" />,
    caption: "변경관리",
    items: [
      {
        id: 1,
        icon: <SettingsApplicationsIcon />,
        subTitle: "변경요청서 서식관리",
        url: "/Document/List/5",
      },
      {
        id: 2,
        icon: <FilterListOffIcon />,
        subTitle: "변경요청서 작성 요령관리",
        url: "/WorkOrder/ManageChangeTip",
      },
      {
        id: 3,
        icon: <FormatAlignJustifyIcon />,
        subTitle: "변경이력서 관리",
        url: "/WorkOrder/ChangeRequestList",
      },
    ],
  },

  {
    id: 7,
    icon: <NewReleasesIcon color="primary" />,
    caption: "공정위험성평가관리",
    items: [
      {
        id: 1,
        icon: <GppMaybeIcon />,
        subTitle: "위험성평가 결과 서식관리",
        url: "/Document/List/0",
      },
    ],
  },

  {
    id: 8,
    icon: <DangerousIcon color="primary" />,
    caption: "작업위험성평가관리",
    items: [
      {
        id: 1,
        icon: <AddchartIcon />,
        subTitle: "작업위험성평가 설정",
        url: "/Permission/Configure/",
      },
      {
        id: 2,
        icon: <AppRegistrationIcon />,
        subTitle: "작업위험성평가 목록",
        url: "/Permission/List",
        state: 0,
      },
    ],
  },
  {
    id: 9,
    icon: <AssignmentTurnedInIcon color="primary" />,
    caption: "가동점검관리",
    items: [
      {
        id: 1,
        icon: <IsoIcon />,
        subTitle: "가동점검표 서식관리",
        url: "/Document/ListRevision/1",
      },
      {
        id: 2,
        icon: <StackedLineChartIcon />,
        subTitle: "가동점검표 작성",
        url: "/Document/CreateRevision",
        state: 1,
      },
    ],
  },
  {
    id: 10,
    icon: <SchoolIcon color="primary" />,
    caption: "근로자 교육관리",
    items: [
      {
        id: 1,
        icon: <ReviewsIcon />,
        subTitle: "평가",
        url: "/Education/MyEval",
      },

      {
        id: 2,
        icon: <CastForEducationIcon />,
        subTitle: "근로자교육 평가관리",
        url: "/education/curriculumList",
      },
      {
        id: 3,
        icon: <AccountCircleIcon />,
        subTitle: "강사관리",
        url: "/education/TutorList",
      },
      {
        id: 4,
        icon: <SafetyDividerIcon />,
        subTitle: "분류관리",
        url: "/education/CategoryList",
      },
    ],
  },
  {
    id: 11,
    icon: <DescriptionIcon color="primary" />,
    caption: "공정안전보고서",
    items: [
      {
        id: 1,
        icon: <ArticleIcon />,
        subTitle: "공정안전보고서",
        url: "/Archive/",
      },
    ],
  },
  {
    id: 12,
    icon: <IntegrationInstructionsIcon color="primary" />,
    caption: "사용자 설명서",
    items: [
      {
        id: 1,
        icon: <AssignmentLateIcon />,
        subTitle: "사용자 설명서",
        url: "/Manual",
      },
    ],
  },
];

// note level 1 or 2
export const superMenu: interfaces.NavMenu[] = [
  {
    id: 0,
    icon: <AdminPanelSettingsIcon color="secondary" />,
    caption: "최고 관리자",
    items: [
      {id: 1, icon: <BusinessIcon color="secondary" />, subTitle: "업체", url: "/Company"},
      {
        id: 2,
        icon: <SwitchAccountIcon color="secondary" />,
        subTitle: "업체 관리자",
        url: "/Manager",
      },
      {
        id: 3,
        icon: <ContentPasteIcon color="secondary" />,
        subTitle: "게시판 관리자",
        url: "/BoardManager",
      },
      {
        id: 4,
        icon: <SwitchAccountIcon color="secondary" />,
        subTitle: "질의, 오류보고",
        url: "/Suggestion/All",
      },
    ],
  },
  {
    id: 1,
    icon: <HomeIcon color="primary" />,
    caption: "Home",
    items: [{id: 1, icon: <QuestionAnswerIcon />, subTitle: "Home", url: "/Home/Dashboard"}],
  },
];

// note level 3
export const managerMenu: interfaces.NavMenu[] = [
  {
    id: 2,
    icon: <ManageAccountsIcon color="primary" />,
    caption: "관리자설정",
    items: [
      {id: 1, icon: <LocalFireDepartmentIcon />, subTitle: "부서관리", url: "/Department"},
      {
        id: 2,
        icon: <PersonAddAlt1Icon />,
        subTitle: "담당자",
        url: "/Officer",
      },
      {id: 3, icon: <LegendToggleIcon />, subTitle: "통계관련 범례내용", url: "/Statistics"},
      {id: 4, icon: <CreditCardIcon />, subTitle: "신뢰도 관리", url: "/Equipment/Reliability"},
      {id: 5, icon: <ContentPasteIcon />, subTitle: "질의 오류보고", url: "/Suggestion"},
    ],
  },
  {
    id: 3,
    icon: <HomeIcon color="primary" />,
    caption: "Home",
    items: [{id: 1, icon: <QuestionAnswerIcon />, subTitle: "Home", url: "/Home/Dashboard"}],
  },
  {
    id: 4,
    icon: <HomeRepairServiceIcon color="primary" />,
    caption: "설비유지관리",
    items: [
      {id: 1, icon: <CardTravelIcon />, subTitle: "설비이력카드목록", url: "/Equipment"},
      {
        id: 2,
        icon: <TransformIcon />,
        subTitle: "점검 정비 수 발신 목록",
        url: "/WorkOrder",
      },
      {
        id: 3,
        icon: <FormatListBulletedIcon />,
        subTitle: "점검 요청 목록",
        url: "/WorkOrder/RequestedList",
      },
      {id: 4, icon: <HistoryToggleOffIcon />, subTitle: "점검 이력", url: "/WorkOrder/Record"},
    ],
  },
  {
    id: 5,
    icon: <EngineeringIcon color="primary" />,
    caption: "My 점검·정비목록",
    items: [
      {id: 1, icon: <ReplyAllIcon />, subTitle: "수신목록", url: "/WorkOrder/List/Received"},
      {
        id: 2,
        icon: <CachedIcon />,
        subTitle: "진행목록",
        url: "/WorkOrder/List/Processed",
      },
      {id: 3, icon: <TaskIcon />, subTitle: "완료목록", url: "/WorkOrder/List/Completed"},
    ],
  },
  {
    id: 6,
    icon: <ChangeCircleIcon color="primary" />,
    caption: "변경관리",
    items: [
      {
        id: 1,
        icon: <SettingsApplicationsIcon />,
        subTitle: "변경요청서 서식관리",
        url: "/Document/List/5",
      },
      {
        id: 2,
        icon: <FilterListOffIcon />,
        subTitle: "변경요청서 작성 요령관리",
        url: "/WorkOrder/ManageChangeTip",
      },
    ],
  },
  {
    id: 7,
    icon: <NewReleasesIcon color="primary" />,
    caption: "공정위험성평가관리",
    items: [
      {
        id: 1,
        icon: <GppMaybeIcon />,
        subTitle: "위험성평가 결과 서식관리",
        url: "/Document/List/0",
      },
    ],
  },

  {
    id: 8,
    icon: <DangerousIcon color="primary" />,
    caption: "작업위험성평가관리",
    items: [
      {
        id: 1,
        icon: <AddchartIcon />,
        subTitle: "작업위험성평가 설정",
        url: "/Permission/Configure/",
      },
    ],
  },
  {
    id: 9,
    icon: <AssignmentTurnedInIcon color="primary" />,
    caption: "가동점검관리",
    items: [
      {
        id: 1,
        icon: <IsoIcon />,
        subTitle: "가동점검표 서식관리",
        url: "/Document/ListRevision/1",
      },
      {
        id: 2,
        icon: <StackedLineChartIcon />,
        subTitle: "가동점검표 작성",
        url: "/Document/CreateRevision",
        state: 1,
      },
    ],
  },
  {
    id: 10,
    icon: <SchoolIcon color="primary" />,
    caption: "근로자 교육관리",
    items: [
      {
        id: 2,
        icon: <CastForEducationIcon />,
        subTitle: "근로자교육 평가관리",
        url: "/education/curriculumList",
      },
      {
        id: 3,
        icon: <AccountCircleIcon />,
        subTitle: "강사관리",
        url: "/education/TutorList",
      },
      {
        id: 4,
        icon: <SafetyDividerIcon />,
        subTitle: "분류관리",
        url: "/education/CategoryList",
      },
    ],
  },
  {
    id: 11,
    icon: <DescriptionIcon color="primary" />,
    caption: "공정안전보고서",
    items: [
      {
        id: 1,
        icon: <ArticleIcon />,
        subTitle: "공정안전보고서",
        url: "/Archive/",
      },
    ],
  },
  {
    id: 12,
    icon: <IntegrationInstructionsIcon color="primary" />,
    caption: "사용자 설명서",
    items: [
      {
        id: 1,
        icon: <AssignmentLateIcon />,
        subTitle: "사용자 설명서",
        url: "/Manual",
      },
    ],
  },
];
// note level 4
export const OfficerMenu: interfaces.NavMenu[] = [
  {
    id: 3,
    icon: <HomeIcon color="primary" />,
    caption: "Home",
    items: [{id: 1, icon: <QuestionAnswerIcon />, subTitle: "Home", url: "/Home/Dashboard"}],
  },
  {
    id: 4,
    icon: <HomeRepairServiceIcon color="primary" />,
    caption: "설비유지관리",
    items: [
      {id: 1, icon: <CardTravelIcon />, subTitle: "설비이력카드목록", url: "/Equipment"},
      {
        id: 2,
        icon: <TransformIcon />,
        subTitle: "점검 정비 수 발신 목록",
        url: "/WorkOrder",
      },
      {
        id: 3,
        icon: <FormatListBulletedIcon />,
        subTitle: "점검 요청 목록",
        url: "/WorkOrder/RequestedList",
      },
      {id: 4, icon: <HistoryToggleOffIcon />, subTitle: "점검 이력", url: "/WorkOrder/Record"},
      {
        id: 5,
        icon: <EditRoadIcon />,
        subTitle: "의뢰서 작성",
        url: "/WorkOrder/SelectSpecification",
      },
    ],
  },
  {
    id: 5,
    icon: <EngineeringIcon color="primary" />,
    caption: "My 점검·정비목록",
    items: [
      {id: 1, icon: <ReplyAllIcon />, subTitle: "수신목록", url: "/WorkOrder/List/Received"},
      {
        id: 2,
        icon: <CachedIcon />,
        subTitle: "진행목록",
        url: "/WorkOrder/List/Processed",
      },
      {id: 3, icon: <TaskIcon />, subTitle: "완료목록", url: "/WorkOrder/List/Completed"},
    ],
  },
  {
    id: 6,
    icon: <ChangeCircleIcon color="primary" />,
    caption: "변경관리",
    items: [
      {
        id: 3,
        icon: <FormatAlignJustifyIcon />,
        subTitle: "변경이력서 관리",
        url: "/WorkOrder/ChangeRequestList",
      },
    ],
  },
  {
    id: 8,
    icon: <DangerousIcon color="primary" />,
    caption: "작업위험성평가관리",
    items: [
      {
        id: 2,
        icon: <AppRegistrationIcon />,
        subTitle: "작업위험성평가 목록",
        url: "/Permission/List",
        state: 0,
      },
    ],
  },

  {
    id: 10,
    icon: <SchoolIcon color="primary" />,
    caption: "근로자 교육관리",
    items: [
      {
        id: 1,
        icon: <ReviewsIcon />,
        subTitle: "평가",
        url: "/Education/MyEval",
      },
    ],
  },
  {
    id: 11,
    icon: <DescriptionIcon color="primary" />,
    caption: "공정안전보고서",
    items: [
      {
        id: 1,
        icon: <ArticleIcon />,
        subTitle: "공정안전보고서",
        url: "/Archive/",
      },
    ],
  },
  {
    id: 12,
    icon: <IntegrationInstructionsIcon color="primary" />,
    caption: "사용자 설명서",
    items: [
      {
        id: 1,
        icon: <AssignmentLateIcon />,
        subTitle: "사용자 설명서",
        url: "/Manual",
      },
    ],
  },
];
// note level 5

export const boardMenu: interfaces.NavMenu[] = [
  {
    id: 1,
    icon: <AssignmentIndIcon color="primary" />,
    caption: "게시판관리자",
    items: [{id: 1, icon: <ContentPasteSearchIcon />, subTitle: "게시판 목록", url: "/Board"}],
  },
  {
    id: 2,
    icon: <HomeIcon color="primary" />,
    caption: "Home",
    items: [{id: 1, icon: <QuestionAnswerIcon />, subTitle: "Home", url: "/Home/Dashboard"}],
  },
];
